import { render } from "./BreadCrumb.vue?vue&type=template&id=bc7457dc&scoped=true&ts=true"
import script from "./BreadCrumb.vue?vue&type=script&lang=ts"
export * from "./BreadCrumb.vue?vue&type=script&lang=ts"

import "./BreadCrumb.vue?vue&type=style&index=0&id=bc7457dc&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc7457dc"]])

export default __exports__